import { Box, Grid, IconButton, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import * as colours from '@cbgms/components/src/order-parts/parts/stock/ColourConst'
import VisibilityIcon from '@mui/icons-material/Visibility'

export interface AttachmentItemProps {
  url: string
  view: boolean
  handleClick: (item: string) => void
  default: boolean
  handleCancelClick?: (item: string) => void
  marginbottom: number
  allowFileRemoval: boolean
  showVisibilityIcon?: boolean // Made optional with default value
}

export const AttachmentItem = (props: AttachmentItemProps) => {
  const title = props.url.substring(props.url.lastIndexOf('/') + 1)
  const theme = useTheme()
  const showVisibilityIcon = props.showVisibilityIcon ?? true // Default value set to true
  return (
    <Grid
      item
      key={title}
      xs={12}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: props.default ? `2px solid ${theme.palette.grey[300]}` : `1px solid ${theme.palette.primary.main}`,
        backgroundColor: props.default ? `${theme.palette.grey[200]}` : colours.bgDefault,
        padding: 1,
        borderRadius: 1,
        marginBottom: props.marginbottom
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InsertDriveFileIcon color='primary' sx={{ fontSize: 24 }} />
        <Typography
          variant='body1'
          color='primary'
          sx={{
            fontWeight: 600,
            cursor: 'pointer'
          }}
          onClick={() => props.handleClick(props.url)}
        >
          {title}
        </Typography>
      </Box>
      {props.allowFileRemoval ? (
        <IconButton aria-label='cancel' onClick={() => props.handleCancelClick?.(props.url)} data-testid='attachment-cancel-btn'>
          <CloseIcon color='primary' />
        </IconButton>
      ) : (
        showVisibilityIcon && (
          <IconButton aria-label='view' onClick={() => props.handleClick(props.url)} data-testid='attachment-view-btn'>
            <VisibilityIcon color='primary' sx={{ ml: 'auto' }} />
          </IconButton>
        )
      )}
    </Grid>
  )
}
